import Vue from 'vue'
import App from './App.vue'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from "./store/store.js";
//import VueLazyload from 'vue-lazyload';

Vue.config.productionTip = false
Vue.use(VueLodash, { name: 'custom', lodash: lodash })
Vue.use(VueRouter)
Vue.use(VueAxios, axios)
//Vue.use(VueLazyload)

var router = new VueRouter({
  mode: 'history',
  routes: []
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
